export default __webpack_public_path__ + "static/media/ai_face_recognition.c12eebb4.svg";